import { mapState } from 'vuex';
import parseAvailableLocales from '@/helpers/parseAvailableLocales';
import cloneDeep from 'lodash/cloneDeep';

export default function invoicePageLocales(messages) {
  return {
    data() {
      return {
        defaultLocales: [],
      };
    },

    computed: {
      ...mapState(['checkoutOptions']),
      ...mapState('UI', ['availableLocales', 'queryLocale']),

      locales() {
        let data = cloneDeep(this.defaultLocales);

        const optionLocales = parseAvailableLocales(
          this.availableLocales,
          this.checkoutOptions?.available_locales,
          Object.keys(messages)
        );

        if (optionLocales.length) {
          data = optionLocales;

          if (
            this.selectedLocale &&
            Object.keys(messages).some(key => key === this.selectedLocale) &&
            !data.some(locale => locale === this.selectedLocale)
          ) {
            data.push(this.selectedLocale);
          }
        }

        return data;
      },

      selectedLocale() {
        const supportedLocale = locale =>
          Object.keys(messages).some(key => key === locale) ? locale : null;

        return (
          supportedLocale(this.defaultLocale) ||
          supportedLocale(this.queryLocale) ||
          supportedLocale(this.checkoutOptions?.locale) ||
          supportedLocale(this.$browserLocale)
        );
      },
    },

    methods: {
      initDefaultLocales() {
        this.defaultLocales = this.checkLocaleIsSupportInPage(this.selectedLocale)
          ? this.selectedLocale === 'en'
            ? ['en']
            : [this.selectedLocale, 'en']
          : ['en'];
      },

      checkLocaleIsSupportInPage(locale) {
        return Object.keys(messages).some(key => key === locale);
      },

      applyInitialLocale() {
        if (this.locales.includes(this.selectedLocale)) {
          this.selectLocale(this.selectedLocale);
        } else {
          this.selectLocale(this.locales.length ? this.locales[0] : 'en');
        }
      },

      selectLocale(locale) {
        this.$bus.$emit('changeLocale', locale);
      },
    },
  };
}
